<template>
    <v-container app :fluid="true">
        <v-row>
            <v-col cols="4" class="pt-0">
                <v-text-field
                    v-model="search"
                    append-icon="fas fa-search"
                    label="Buscar modelo"
                    hide-details
                    solo
                    dense
                    class="wost-text-input"
                ></v-text-field>
            </v-col>
            <v-col cols="8" class="pt-0">
                <v-btn 
                    @click="handleViewCreate" 
                    rised 
                    color="indigo" 
                    dark
                    class="float-right wost-btn-new" 
                    v-if="verifyPermission('crear_modelos')">
                    <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo Modelo
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="patterns"
                        item-key="id"
                        :search="search"
                        height="68vh"
                        fixed-header
                        v-if="verifyPermission('listar_modelos')"
                    >

                        <template v-slot:item.name="{item}">
                            {{ item.name | lowercase }}
                        </template>

                        <template v-slot:item.brand_id="{item}">
                            <span v-if="item.brand">
                                {{ item.brand.name }}
                            </span>
                        </template>

                        <template v-slot:item.action="{ item }">
                            <div class="datatable-cell-wrapper">
                                <a href="#" 
                                    title="Editar" 
                                    class="btn-actions btn-edit" 
                                    @click="handleEdit(item)"
                                    v-if="verifyPermission('actualizar_modelos')">
                                    <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                                </a>
                                &nbsp;
                                <a v-if="item.status  === 'activo' && verifyPermission('inactivar_modelos')" 
                                    href="#" 
                                    title="Inactivar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'inactivar')">
                                    <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                                </a>
                                <a v-else-if="item.status  === 'inactivo' && verifyPermission('activar_modelos')" 
                                    href="#" 
                                    title="Activar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'activar')">
                                    <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                                </a>
                            </div>
                        </template>

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <create-update ref="createUpdate"></create-update>
    </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex';

import CreateUpdate from '../../components/patterns/CreateUpdate';

export default {
    name: 'Patterns',
    components: {
        CreateUpdate
    },
    data () {
        return {
            search: null,
            headers: [
                { text: 'Nombre', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Marca', value: 'brand_id', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', align: 'end' }
            ],
        }
    },
    computed: {
        ...mapState('brands', [
            'brands'
        ]),
        ...mapState('patterns', [
            'patterns',
            'pattern_response'
        ])
    },
    methods: {
        ...mapActions('brands', [
            'getBrands'
        ]),
        ...mapActions('patterns', [
            'getPatterns',
            'change_status'
        ]),
        handleViewCreate () {
            this.$refs.createUpdate.show('Registrar nuevo modelo', 'create');
        },
        handleEdit (pattern) {
            let formData = Object.assign({}, pattern);
            this.$refs.createUpdate.show('Actualizar modelo', 'update', pattern);
        },
        changeStatus (pattern, status) {
            this.$swal({
                title: "¿Desea confirmar?",
                text: "Confirma que desea " + status + " el modelo",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar",
            }).then( async (result) => {
                if(result.value){
                    if(result.value === true){
                        await this.change_status(pattern);
                        if (this.pattern_response == 'error') {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                title: 'ACTUALIZACION DE MODELO',
                                text: 'Ocurrió un error al cambiar estado de modelo.'
                            });
                        } else {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'ACTUALIZACION DE MODELO',
                                text: 'El estado de modelo fue actualizado de forma correcta.'
                            });
                        }
                    }
                }                    
            })
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    created () {
        this.getBrands();
        this.getPatterns();
    }
}
</script>

<style scoped>

</style>